import { useEffect } from 'react';
import { useUIStore } from '@/state/store';

export function useGlobalShortcuts() {
  const setView = useUIStore((s) => s.setView);

  useEffect(() => {
    function onKey(e: KeyboardEvent) {
      const target = e.target as HTMLElement;
      const isTyping = target.tagName === 'INPUT' || target.tagName === 'TEXTAREA';

      const state = useUIStore.getState();

      if (e.key === 'Escape') {
        if (state.cmdkOpen) state.closeCmdK();
        if (state.escalateOpen || state.transferOpen) state.closeDrawers();
        if (state.settingsOpen) state.toggleSettings();
        return;
      }

      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'k') {
        e.preventDefault();
        state.openCmdK();
        window.dispatchEvent(new CustomEvent('bamoa:focus-search'));
        return;
      }

      if (isTyping) return;

      const inCall = state.view.startsWith('incall');
      if (!inCall) return;

      const k = e.key.toLowerCase();
      switch (k) {
        case 'm':
          e.preventDefault();
          state.toggleMic();
          break;
        case 'c':
          e.preventDefault();
          state.toggleCam();
          break;
        case 's':
          e.preventDefault();
          // Welle 8c: echtes Toggle der Bildschirmfreigabe — InCall hört auf das Event.
          window.dispatchEvent(new CustomEvent('bamoa:toggle-share'));
          break;
        case 'r':
          e.preventDefault();
          state.toggleRecording();
          break;
        case 'i':
          e.preventDefault();
          state.toggleInspection();
          break;
        case 't':
          e.preventDefault();
          state.toggleTranslation();
          break;
        case '1':
          e.preventDefault();
          if (state.docFocused) state.swapCameras();
          break;
        case '2':
          e.preventDefault();
          if (!state.docFocused) state.swapCameras();
          break;
        default:
          break;
      }

      if ((e.metaKey || e.ctrlKey) && k === 'e') {
        e.preventDefault();
        state.openEscalate();
      } else if ((e.metaKey || e.ctrlKey) && k === 'w') {
        e.preventDefault();
        state.openTransfer();
      } else if ((e.metaKey || e.ctrlKey) && k === 'h') {
        e.preventDefault();
        state.setView('wrap');
      }
    }

    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [setView]);
}
